'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fadeOut = require('./fade-out');

var _fadeOut2 = _interopRequireDefault(_fadeOut);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _omit = require('lodash/object/omit');

var _omit2 = _interopRequireDefault(_omit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var MultiSelect = _react2['default'].createClass({
    displayName: 'MultiSelect',


    propTypes: {
        initiallySelectedOptionValues: _react2['default'].PropTypes.array.isRequired,
        onSelectionChange: _react2['default'].PropTypes.func.isRequired,
        disabled: _react2['default'].PropTypes.bool,

        options: function options(props, propName, componentName) {
            if (props[propName] === undefined || !$.isArray(props[propName])) {
                throw new Error(propName + ' must be an array for ' + componentName);
            }
            props[propName].forEach(function (entry) {
                if (entry.key === undefined) {
                    throw new Error('key attribute must exist for each entry of ' + propName + ' for ' + componentName);
                }
                if (entry.descr === undefined) {
                    throw new Error('descr attribute must exist for each entry of ' + propName + ' for ' + componentName);
                }
            });
        },
        statusMessage: function statusMessage(props, propName, componentName) {
            if (props[propName]) {
                if (props[propName].className === undefined) {
                    throw new Error(propName + '.className must be defined for ' + componentName);
                }
                if (props[propName].text === undefined) {
                    throw new Error(propName + '.text must be defined for ' + componentName);
                }
            }
        }
    },

    // Just a band-aid to prevent react from making the multi-select from disappearing. Fix
    // is to refactor this component to be entirely reactified. (CC)
    shouldComponentUpdate: function shouldComponentUpdate() {
        return !this.preventRerender;
    },
    getInitialState: function getInitialState() {
        return {
            selectedOptionValues: this.props.initiallySelectedOptionValues
        };
    },
    componentDidMount: function componentDidMount() {
        this._setupMultiSelect();
    },
    componentDidUpdate: function componentDidUpdate() {
        this._setupMultiSelect();
    },
    _setupMultiSelect: function _setupMultiSelect() {
        var self = this;
        var selectEl = $('select', _reactDom2['default'].findDOMNode(this));

        selectEl.multiselect('destroy');

        selectEl.multiselect({
            selectEl: this,
            minWidth: 300,
            maxHeight: 300,
            noneSelectedText: 'Please select one',
            open: function open() {
                self.preventRerender = true;
            },
            selectedText: function selectedText(num, total, checkedEls) {
                if (num > 2) {
                    return checkedEls[0].title + ' and ' + (num - 1) + ' more';
                } else if (num == 2) {
                    return checkedEls[0].title + ' and ' + checkedEls[1].title;
                } else if (num == 1) {
                    return checkedEls[0].title;
                }
            },
            close: function close() {

                self.preventRerender = false;

                if (self.props.disabled) {
                    return;
                }
                // FIXME: onChange and .selectedOptions both don't work when we use jQuery multiselect plugin, so we have to go this less React-y route of fetching data from the DOM using jQuery
                var checkedEls = selectEl.multiselect('getChecked');
                var checkedValues = checkedEls.map(function () {
                    return this.value;
                }).get();

                self.props.onSelectionChange(checkedValues);
                self.setState({ selectedOptionValues: checkedValues });
            }
        });

        if (this.props.disabled) {
            selectEl.multiselect('disable');
        }
    },
    render: function render() {
        var selectionOptions = this.props.options.map(function (option) {
            return _react2['default'].createElement(
                'option',
                { key: option.key, value: option.key },
                option.descr
            );
        }, this);

        var msg = this.props.statusMessage ? _react2['default'].createElement(
            _fadeOut2['default'],
            { key: this.state.selectedOptionValues + this.props.statusMessage.text },
            _react2['default'].createElement(
                'div',
                { className: 'message ' + this.props.statusMessage.className },
                this.props.statusMessage.text
            )
        ) : null;

        return _react2['default'].createElement(
            'span',
            (0, _omit2['default'])(this.props, ['app', 'options', 'initiallySelectedOptionValues', 'onSelectionChange', 'statusMessage']),
            _react2['default'].createElement(
                'span',
                null,
                _react2['default'].createElement(
                    'select',
                    { className: this.props.disabled ? 'disabled' : '', multiple: 'multiple', defaultValue: this.state.selectedOptionValues },
                    selectionOptions
                )
            ),
            msg
        );
    }
});

module.exports = MultiSelect;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/multi-select.jsx
 ** module id = 1206
 ** module chunks = 0
 **/